export default {
  id: "event-days",
  name: "Event Dates",
  settings: {}
};
